import {
  Input,
  InputProps,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/input";
import React from "react";
import { CheckIcon } from "../../../styles/icons";
import { BaseFieldProps, FieldWrapper } from "../FieldWrapper/FieldWrapper";

interface TextFieldProps extends BaseFieldProps {
  isValid?: boolean;
}

export const TextField = ({
  name,
  label,
  id,
  helperText,
  isValid,
  infoText,
  labelRightElement,
  fcProps,
  valueProps,
  labelProps,
  horizontal,
  hideField,
  ...inputProps
}: TextFieldProps & InputProps) => {
  return (
    <FieldWrapper
      name={name}
      id={id}
      label={label}
      helperText={helperText}
      infoText={infoText}
      labelRightElement={labelRightElement}
      horizontal={horizontal}
      fcProps={fcProps}
      labelProps={labelProps}
      valueProps={valueProps}
      hideField={hideField}
    >
      {({ field }) => (
        <InputGroup shadow="sm">
          <Input
            {...field}
            value={field.value == null ? "" : field.value}
            backgroundColor="white"
            {...inputProps}
          />
          {isValid && (
            <InputRightElement children={<CheckIcon color="green.400" />} />
          )}
        </InputGroup>
      )}
    </FieldWrapper>
  );
};
